export const ReferenceType = {
  ORDER: 'order',
  ORDER_LINE_ITEM: 'order_line_item',
} as const
export type ReferenceType = typeof ReferenceType[keyof typeof ReferenceType]
